import { render, staticRenderFns } from "./dataStatisticsIndex.vue?vue&type=template&id=66cd15a4&scoped=true&"
import script from "./dataStatisticsIndex.vue?vue&type=script&lang=js&"
export * from "./dataStatisticsIndex.vue?vue&type=script&lang=js&"
import style0 from "./dataStatisticsIndex.vue?vue&type=style&index=0&id=66cd15a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66cd15a4",
  null
  
)

export default component.exports